import React, {useContext, useEffect} from 'react';
import {AgentContext} from "../context/agent-context.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import Alert from "../../../../../components/alert/alert.jsx";
import InputSwitch from "../../../../../components/input/input-switch.jsx";

const UserShared = ({userId}) => {
    const {user, shared, setShared, devices, userInfo, setChanges} = useContext(AgentContext)

    useEffect(() => {
        if (!user.general.nameWar || !user.user.status) {
            setShared(prev => ({...prev, shareContactInfo: false}));
        }

        if (!user.general.email) setShared(prev => ({...prev, shareEmail: false}));
    }, [user]);

    useEffect(() => {
        if (!shared.shareContactInfo) {
            setShared(prev => ({
                ...prev,
                shareEmail: false,
                sharedDevice: null,
                focalPoints: []
            }));
        }
    }, [shared.shareContactInfo]);

    const handleChecked = (id, checked) => {
        setShared(prev => ({...prev, [id]: checked}));
        setChanges('general');
    }

    return (
        <Card>
            <Card.Header>
                <Card.Title>Compartilhar com outras corporações que utilizam o Sentry</Card.Title>
            </Card.Header>
            <Card.Body className={"gap-4"}>
                {
                    (!user.user.status) &&
                    <Alert target={"danger"} className={"mb-2"}>
                        Para compartilhar os dados do agente é necessário que ele esteja ativo.
                    </Alert>
                }
                {
                    !user.general.nameWar &&
                    <Alert target={"danger"} className={"mb-2"}>
                        Para compartilhar os dados do agente informe o <b>nome de guerra</b>.
                    </Alert>
                }

                <div className={"mb-3"}>
                    <InputSwitch
                        id="shareContactInfo"
                        label={"Ativar compartilhamento"}
                        checked={shared.shareContactInfo}
                        onChange={(checked) => handleChecked("shareContactInfo", checked)}
                        disabled={!user.user.status || !user.general.nameWar}
                    />
                </div>

                <p className={"mb-2"}>Informações a serem exibidas: </p>

                <div className="flex gap-4 mb-3">
                    <InputSwitch
                        label={"Nome de guerra (obrigatório)"}
                        checked={!!user.general.nameWar}
                        disabled={true}
                    />

                    <InputSwitch
                        id="shareEmail"
                        label={"E-Mail"}
                        checked={shared.shareEmail}
                        onChange={(checked) => handleChecked("shareEmail", checked)}
                        disabled={!shared.shareContactInfo || !user.user.status || !user.general.nameWar || !user.general.email}
                    />
                </div>

                <div className="grid grid-cols-12 gap-4 mt-3">
                    <div className="col-span-6">
                        <SelectComponent
                            id="sharedDevice"
                            value={shared.sharedDevice}
                            options={devices.filter(d => d.id)}
                            label={"Contato"}
                            onChange={(value) => {
                                setShared(prev => ({...prev, sharedDevice: value}))
                                setChanges('user');
                            }}
                            isDisabled={!shared.shareContactInfo || !userId || !user.user.status || !user.general.nameWar}
                        />
                    </div>

                    <div className="col-span-6">
                        <SelectComponent
                            id="focalPoints"
                            value={shared.focalPoints}
                            options={userInfo?.focalPoints ?? []}
                            label={"Ponto focal"}
                            onChange={(value) => {
                                setShared(prev => ({...prev, focalPoints: value}))
                                setChanges('general');
                            }}
                            isDisabled={!shared.shareContactInfo || !user.user.status || !user.general.nameWar}
                            isMulti
                        />
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default UserShared;